<template>
    <div class="visualGuideNotice">
        <div class="notice-container">
            <div class="info-box">
                <p>学校：{{viewData.schoolName}}</p>
                <p>日期：{{viewData.supervisionDate}}</p>
            </div>
            <div class="tab-box">
                <p class="tab-title">学科及教师</p>
                <label @click="handleDownload"><i class="icon-tab bg-icon"></i>下载表格</label>
            </div>
            <div class="tab-top" v-for="(item,index) in viewData.stageSubjectVOS" :key="index">
                <label>{{item.stageName}}</label>
                <table>
                    <tr>
                        <td>序号</td>
                        <td>学科</td>
                        <td>教师</td>
                        <td>性别</td>
                    </tr>
                    <tr v-for="(v,i) in item.subjectNameVOS" :key="i">
                        <td>{{i+1}}</td>
                        <td>{{v.subjectName}}</td>
                        <td>{{v.teacherName}}</td>
                        <td>{{v.sex==0?'男':'女'}}</td>
                    </tr>
                </table>
            </div>
            <p class="remark">请校方知悉</p>
        </div>
        <van-popup v-model="copyPopup" :closeable="true" :close-on-click-overlay="false">
            <div class="content-box">
                <p class="address">{{downUrl}}</p>
                <p class="tips">复制链接前往PC端下载</p>
                <div class="copy-btn">
                    <van-button type="primary" color="#334EB4" size="large" :round="true" :data-clipboard-text="downUrl" class="clipboardName" @click="copy('.clipboardName')">复制地址</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { getNoticeInfo, downloadTable, getTableLink } from '@/api/common';
import ClipboardJS from 'clipboard';
export default {
  components: {},
  data() {
    return {
      planId: '',
      viewData: {},
      copyPopup: false,
      downUrl: 'http://192.168.124.225:8080/#/v1/qws/download/supervision/teacher-table'
    };
  },
  created() {
    this.planId = this.$route.query.planId;
    this.queryNoticeInfo();
  },
  methods: {
    // 复制功能
    copy(el) {
      const clipboard = new ClipboardJS(el);
      clipboard.on('success', () => {
        this.$toast.success('复制成功');
        clipboard.on('destory');
      });
      clipboard.on('error', () => {
        this.$toast('复制失败');
        clipboard.on('destory');
      });
    },
    queryNoticeInfo() {
      getNoticeInfo(this.planId).then(res => {
        this.viewData = res.data;
      });
    },
    handleDownload() {
      const u = navigator.userAgent;
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isIOS) { // 判断如果是IOS手机
        getTableLink(this.planId).then(res => {
          this.downUrl = res.data;
        });
        this.copyPopup = true;
      } else {
        window.location.href = downloadTable(this.planId);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.visualGuideNotice{
    // &::before {
    //     position: fixed;
    //     z-index: -1;
    //     background-size: 100% 100%;
    //     width: 100%;
    //     height: 100%;
    //     top: 0;
    //     left: 0;
    //     background: #f4f4f4;
    //     content: '';
    // }
    .notice-container{
        background: #fff;
        border-radius: 5px;
        margin: 15px;
        padding: 15px 15px;
        .info-box{
            font-size: 14px;
            color: #333333;
            line-height: 24px;
            border-bottom: 1px dashed #BBBBBB;
            padding-bottom: 15px;
        }
        .tab-box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .tab-title{
                font-size: 14px;
                color: #333333;
                margin:20px 0 15px 0;
            }
            label{
                font-size: 12px;
                color: #334EB4;
            }
            .icon-tab{
                display: inline-block;
                width: 12px;
                height: 12px;
                background-image: url('../../assets/img/icon-tab.png');
                vertical-align: text-top;
                margin-right: 10px;
            }
        }
        .tab-top{
            font-size: 12px;
            color: #334EB4;
            margin-bottom: 10px;
        }
        .remark{
            font-size: 12px;
            color: #787878;
            margin-top: 9px;
            padding-bottom: 40px;
        }
    }
    table, td, th {
        border: 1px solid #CDCDCD;
        padding: 10px 0;
    }
    table {
        border-collapse: collapse;
        width: 100%;
        margin-top: 10px;
    }
    td{
        font-size: 12px;
        color: #333333;
        text-align: center;
        &:first-child{
            width: 40px;
        }
    }
    tr{
        &:nth-child(odd){
            background: #f9f9f9;
        }
    }
    .content-box{
        width: 300px;
        height: 50%;
        .address{
            padding: 15px;
            word-break: break-all;
            font-size: 14px;
            margin-top: 30px;
            color: #333333;
            line-height: 26px;
        }
        .tips{
            font-size: 14px;
            text-align: center;
        }
        .copy-btn{
            padding: 30px;
        }
    }
}
</style>
